import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Button } from '@hhgtech/hhg-components/mantine'
import { ArrowRight } from '@hhgtech/icons/other'
import { AspectRatio, Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { useIntl } from 'react-intl'
// import { useHandlerUrls } from 'hooks/useHandlerUrls'
import { RichTextFormat } from 'components/atoms/richTextFormat'
import { useIsMobile } from 'hooks/useIsMobile'

type Props = {
  heading: string
  description: string
  thumbnail: string
  url: string
} & BoxProps

export const InfoCardWithSmallIcon = ({
  heading,
  description,
  thumbnail,
  url,
  className,
  classNames,
  styles,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'InfoCardWithSmallIcon',
    styles,
    classNames,
  })
  const { formatMessage: f } = useIntl()
  const isMobile = useIsMobile()
  // const linkData = useHandlerUrls([url])
  // const { isExternalUrl } = linkData?.[0] || {}
  return (
    <Box
      component={isMobile && url ? 'a' : 'div'}
      {...(isMobile &&
        url && {
          href: url,
          // target={isExternalUrl ? '_blank' : '_self'}
          target: '_blank',
        })}
      className={cx(className, classes.root)}
      data-event-category="App Install"
      data-event-action="Health Tools"
      data-event-label={url}
      {...rest}
    >
      <Box className={classes.info}>
        <Box className={classes.infoTop}>
          <Box className={classes.infoHead}>
            <AspectRatio ratio={1} className={classes.thumbnailFrame}>
              <Box className={classes.thumbnail}>
                <img
                  loading="lazy"
                  src={thumbnail}
                  className={classes.thumbnailImg}
                  alt={heading}
                />
              </Box>
            </AspectRatio>
            {heading && <h4 className={classes.heading}>{heading}</h4>}
          </Box>
          <ArrowRight className={classes.arrow} size={20} />
        </Box>
        {description && (
          <RichTextFormat className={classes.desc} content={description} />
        )}
      </Box>
      {isMobile && url && (
        <Button
          className={classes.btn}
          classNames={{
            rightIcon: classes.btnIcon,
          }}
          variant="secondary"
          rightIcon={<ArrowRight size={18} useCurrentColor />}
        >
          {f({ id: 'common.tryNow', defaultMessage: 'Dùng thử ngay' })}
        </Button>
      )}

      <AspectRatio ratio={429 / 380} className={classes.bg}>
        <img
          loading="lazy"
          src={CommonGAssets.getAssetPath('appIntro/blue-blur-bg.jpg')}
          alt=""
          className={classes.bgImg}
        />
      </AspectRatio>
    </Box>
  )
}
